import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../utilities/TabGrid";
import {TopButtonPointEdit} from "../../../../../componentsTopsa/buttons/TopButtons";
import TabUtilities from "../../../../../utilities/TabUtilities";
import LSService from "../../../../../utilities/localStorageService/LSService";
import acc from 'accounting'

export default class KierowcyTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterKierowca: false,
        };
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
    }

    componentDidMount() {
        if (Boolean(LSService.pobierzIdKierowcyDoFiltrowania())) {
            this.setState({filterKierowca: LSService.pobierzIdKierowcyDoFiltrowania()})
            LSService.usunIdKierowcyDoFiltrowania()
        }
    }

    renderButtonyAkcji(cell, row) {
        return (
            <div>
                <TopButtonPointEdit onClick={() => {
                    this.props.handleEdytuj(row)
                }} titleContent={'Edytuj kierowcę'}/>
            </div>
        )
    }

    formatStatus(cell, row) {
        if (cell === 1) {
            return <div style={{color: 'forestgreen'}} title={'aktywny'}><i className={'fa fa-check'}></i></div>
        } else return <div style={{color: 'firebrick'}} title={'nieaktywny'}><i className={'fa fa-times'}></i></div>
    }

    formatTelEbus(cell, row) {

        return (<div style={{maxWidth:'268px',overflow:'auto'}}>
            {
                Boolean(row.nrTelEbus) ?
                    <div style={{fontSize: '16px', fontWeight: 'bold'}}>
                        <i className={'fa fa-phone'}></i> {row.nrTelEbus}
                    </div>
                    : ''
            }
            {
                Boolean(row.fcmToken) ?
                    <div style={{fontSize: '12px', color: 'grey'}}>
                        <b>FCM TOKEN:</b>
                        <div>
                        <span style={{wordBreak:'break-all'}}>{row.fcmToken}</span>
                        </div>
                    </div>
                    : ''
            }
        </div>)
    }

    render() {

        let statusy = {
            1: 'aktywny',
            0: 'nieaktywny'
        }

        const options = {
            sizePerPage: 15,  // Showing 15 for the size per page as default
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów'
        };

        return (
            <div className={'bigger_table_for_1399'}>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover
                >
                    <TableHeaderColumn dataField='idKi' isKey hidden={(this.state.filterKierowca === false) ? true : false} thStyle={tabgrid.tg1}
                                       tdStyle={tabgrid.tg1}
                                       filter={{type: 'TextFilter', defaultValue: this.state.filterKierowca, condition: 'eq'}}
                    >ID <span className={'fa fa-times'} onClick={() => this.setState({filterKierowca: false})}
                              style={{color: 'firebrick', cursor: 'pointer'}} title={'Usuń filtrowanie po ID'}></span>
                    </TableHeaderColumn>
                    <TableHeaderColumn dataField='imie'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Imię</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazwisko'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Nazwisko</TableHeaderColumn>
                    <TableHeaderColumn dataField='pesel'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >PESEL</TableHeaderColumn>
                    <TableHeaderColumn dataField='nrTel'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Tel. prywatny</TableHeaderColumn>
                    <TableHeaderColumn dataField='nrTelEbus' dataSort
                                       thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.formatTelEbus}
                    >Telefon służbowy eBus</TableHeaderColumn>
                    <TableHeaderColumn dataField='stanowisko'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Stanowisko</TableHeaderColumn>
                    <TableHeaderColumn dataField='podstawa'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={(cell, row) => {
                                           if (cell || cell == 0) {
                                               return acc.formatMoney(cell)
                                           } else return '-'
                                       }}
                    >Podstawa</TableHeaderColumn>
                    <TableHeaderColumn dataField='dataBadLek'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Badania lekarskie</TableHeaderColumn>
                    <TableHeaderColumn dataField='dataBadBhp'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Badania BHP</TableHeaderColumn>
                    <TableHeaderColumn dataField='dataWaznPrawJazd'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Data ważności PJ</TableHeaderColumn>
                    <TableHeaderColumn dataField='status' dataSort
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={{type: 'SelectFilter', options: statusy, selectText: ''}} formatExtraData={statusy}
                                       dataFormat={this.formatStatus}
                    >Aktywny?</TableHeaderColumn>
                    <TableHeaderColumn dataField='idKi'
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       dataFormat={this.renderButtonyAkcji}
                    >{TabUtilities.returnAkcjaDowolnaHtml('Edytuj', 'grey')}</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/kierowcy/components/KierowcyTable.js